<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-marketing"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base"
                :class="{'farmer': theme == 'farmer', 'subdist': theme == 'subdist', 'dist': theme == 'dist', 'sale': theme == 'sale'}">
                <div class="modal-base-head">
                    <div class="modal-head-txt theme-txt">{{lbl.marketing.title}}</div>
                </div>
                <div class="modal-base-body">
                    <div class="modal-body-txt">{{lbl.marketing.msg}}</div>
                    <div class="content-area">
                        <div class="checkbox-content">
                            <InputCheckBox  v-model="isAll"
                                            :textLbl="lbl.marketing.all"
                                            :all="true"
                                            @onClickAll="onClickAll($event)" />
                            <div class="pad-checkbox"></div>
                            <InputCheckBox  v-model="isSMS"
                                            :textLbl="lbl.marketing.sms"
                                            :sms="true"
                                            @onAcceptSMS="onAcceptSMS($event)" />
                        </div>
                        <div class="checkbox-content">
                            <InputCheckBox  v-model="isEmail"
                                            :textLbl="lbl.marketing.email"
                                            :email="true"
                                            @onAcceptEmail="onAcceptEmail($event)" />
                            <div class="pad-checkbox"></div>
                            <InputCheckBox  v-model="isLine"
                                            :textLbl="lbl.marketing.line"
                                            :line="true"
                                            @onAcceptLine="onAcceptLine($event)" />
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div id="accept_terms_modal"
                        class="btn-wrapper">
                        <div class="btn-txt"
                            @click="submitConsent()">
                            {{lbl.marketing.btn}}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
//hepler
import Locale from '@/helper/locale/locale.js';
import Util from "@/helper/Utility.js";
//component
import InputCheckBox from "@/components/Input/InputCheckBox.vue";
//service
import PDPAService from "@/core/PDPA/service/BzbsPDPA.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
//model
import { PDPAModel } from '@/core/PDPA/model/PDPAModel.js';
export default {
    name: "MarketingModal",
    mixins: [AccountMixin],
    components: {
        InputCheckBox
    },
    props: {
        controller: Object,
        modalId: String,
        theme: String
    },
    data: function () {
        return {
            title: '',
            tag: '',
            btnAcceptTerms: '',
            busModal: null,
            lbl: Locale.getLbl(),
            lblCode: Locale.getLocaleCode(),

            busPDPA: new Vue(),

            isAll: true,
            isEmail: true,
            isSMS: true,
            isLine: true,
            isNotification: true,
            termsVersion: null,
            privacyVersion: null,
            marketingVersion: null,
            token: this.getToken(),
            consent: {},
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
        this.getUserPDPA();
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //control
        show: function(config) {
            this.title = config.title;
            this.btnAcceptTerms = config.btnAcceptTerms;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnAcceptTerms)) {
                this.btnAcceptTerms = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        getUserPDPA: function () {
            PDPAService.apiGetUserPDPA(this.token).then((res) => {
                console.log(res.data);
                var dataPDPA = res.data;
                let consentModel = new PDPAModel();
                this.consent = {
                    termandcondition: dataPDPA.TermAndCondition,
                    dataprivacy: dataPDPA.DataPrivacy,
                    consentAge: dataPDPA.ConsentAge,
                    email: dataPDPA.EmailMarketing,
                    sms: dataPDPA.SMSMarketing,
                    notification: this.isNotification,
                    line: dataPDPA.LineMarketing,
                    marketingOption: dataPDPA.MarketingOption
                }
                consentModel.setPDPAModel(this.consent);
                let params = consentModel.getParams();
                params.email == 0 ? this.isEmail = false : this.isEmail = true;
                params.sms == 0 ? this.isSMS = false : this.isSMS = true;
                params.line == 0 ? this.isLine = false : this.isLine = true;
                this.termsVersion = this.consent.termandcondition;
                this.privacyVersion = this.consent.dataprivacy;
                this.onAcceptEmail(this.isEmail);
                this.onAcceptSMS(this.isSMS);
                this.onAcceptLine(this.isLine);
            })
            .catch((error) => {
                this.errorResponse(error, this.errorHandler);
            });
        },
        onAcceptEmail: function (data) {
            this.isEmail = data;
            if (data) {
                this.isAll = true;
            }
            if (this.isEmail && this.isSMS && this.isLine) {
                this.isAll = true;
            } else {
                this.isAll = false;
            }
        },
        onAcceptSMS: function (data) {
            this.isSMS = data;
            if (data) {
                this.isAll = true;
            }
            if (this.isEmail && this.isSMS && this.isLine) {
                this.isAll = true;
            } else {
                this.isAll = false;
            }
        },
        onAcceptLine: function (data) {
            this.isLine = data;
            if (data) {
                this.isAll = true;
            }
            if (this.isEmail && this.isSMS && this.isLine) {
                this.isAll = true;
            } else {
                this.isAll = false;
            }
        },
        onClickAll: function (all) {
            if (all) {
                this.isEmail = true;
                this.isSMS = true;
                this.isLine = true;
                this.toggle = true;
            } else {
                this.isEmail = false,
                this.isSMS = false,
                this.isLine = false,
                this.toggle = false;
            }
        },
        submitConsent: function () {
            let consentModel = new PDPAModel();
            this.consent = {
                termandcondition: this.termsVersion,
                dataprivacy: this.privacyVersion,
                consentAge: 20,
                email: this.isEmail,
                sms: this.isSMS,
                notification: this.isNotification,
                line: this.isLine,
                marketingOption: this.marketingVersion
            }
            consentModel.setPDPAModel(this.consent);
            let params = consentModel.getParams();
            PDPAService.apiUpdateUserPDPA(this.token, params).then((data) => {
                console.log(data);
                this.hide();
                this.controller.alertModal.clearText()
                                          .setTitle(this.lbl.marketing.alert.title)
                                          .setMsg(this.lbl.marketing.alert.msg)
                                          .setBtnOk(this.lbl.marketing.alert.btn)
                                          .show()
            })
            .catch(err => {
                this.errorResponse(err, this.errorHandler);
            });
        },
    }
}
</script>
<style lang="scss">
@import "@/style/modal.scss";
    .modal-marketing {
        @extend %modal-base;

        .modal-dialog {
            height: 90vh;
            max-height: 90vh;
        }
    }
</style>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    @import "@/style/base/base.scss";
    .modal-marketing {
        @extend %modal-base;

        .modal-base-body {
            .modal-body-txt {
                margin: 15px;
            }

            .content-area {
                margin-top: 15px;
                .checkbox-content {
                    @extend %display-flex-nowrap;
                    width: 100%;
                    padding: 0 30px;
                    .pad-checkbox {
                        padding-right: 20px;
                    }
                }
            }

        }
    }
</style>
